import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { VIDEO_URL } from "@/data/content";

export default function VideoModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="video-modal"
        className="max-w-4xl w-[92vw] p-0 overflow-hidden border-navy/20 bg-navy-dark"
      >
        <DialogTitle className="sr-only">Eğitim Videosu</DialogTitle>
        <DialogDescription className="sr-only">
          Borsa ve yatırım hakkında tanıtım eğitim videosu.
        </DialogDescription>
        <div className="aspect-video w-full bg-black">
          {open && (
            <video
              data-testid="video-iframe"
              className="w-full h-full"
              src={VIDEO_URL}
              controls
              autoPlay
              playsInline
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
